import React, { useState, useCallback, useEffect } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { DragDropContext } from 'react-beautiful-dnd'
import { updateTaskStatus } from '../../Api/task'
import List from '../List/List'
import './board.css'

const Board = ({ filters, tasksData, setSlackShareData }) => {
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  const [data, setData] = useState([])
  useEffect(() => {
    if (tasksData?.length > 0) {
      const selectedFilter = {}
      if (filters.length > 0) {
        filters.forEach((filter) => {
          if (selectedFilter[filter.filter]) {
            if (filter.nature) {
              if (selectedFilter[filter.filter].inList) {
                filter.value.forEach((val) => {
                  const index = selectedFilter[filter.filter].inList.indexOf(
                    val
                  )
                  if (index === -1) {
                    selectedFilter[filter.filter].inList = [
                      ...selectedFilter[filter.filter].inList,
                      val,
                    ]
                  }
                })
              } else {
                selectedFilter[filter.filter].inList = filter.value
              }
            } else {
              if (selectedFilter[filter.filter].notInList) {
                filter.value.forEach((val) => {
                  const index = selectedFilter[filter.filter].notInList.indexOf(
                    val
                  )
                  if (index === -1) {
                    selectedFilter[filter.filter].notInList = [
                      ...selectedFilter[filter.filter].notInList,
                      val,
                    ]
                  }
                })
              } else {
                selectedFilter[filter.filter].notInList = filter.value
              }
            }
          } else {
            selectedFilter[filter.filter] = {}
            if (filter.nature) {
              selectedFilter[filter.filter].inList = filter.value
            } else {
              selectedFilter[filter.filter].notInList = filter.value
            }
          }
        })
      }
      if (selectedFilter['Priority']?.inList) {
        selectedFilter['Priority'].inList = selectedFilter[
          'Priority'
        ].inList.map((item) => item.toUpperCase())
      }
      if (selectedFilter['Priority']?.notInList) {
        selectedFilter['Priority'].notInList = selectedFilter[
          'Priority'
        ].notInList.map((item) => item.toUpperCase())
      }
      const temp = []

      tasksData.forEach((list, index) => {
        let overdue = 0
        temp[index] = {
          status: list.status,
          docs: [],
        }
        if (list.docs.length > 0) {
          list.docs.forEach((task) => {
            let flag = true
            if (selectedFilter['Assignee']) {
              if (selectedFilter['Assignee'].inList?.length > 0) {
                flag = selectedFilter['Assignee'].inList.some(
                  (r) => task.assignee.map((user) => user.email).indexOf(r) >= 0
                )
              }
              if (flag && selectedFilter['Assignee'].notInList?.length > 0) {
                flag = !selectedFilter['Assignee'].notInList.some(
                  (r) => task.assignee.map((user) => user.email).indexOf(r) >= 0
                )
              }
            }

            if (flag && selectedFilter['Nature']) {
              if (selectedFilter['Nature'].inList?.length > 0) {
                flag =
                  selectedFilter['Nature'].inList.indexOf(
                    task.isPrivate ? 'Private' : 'Shared'
                  ) !== -1
              }
              if (flag && selectedFilter['Nature'].notInList?.length > 0) {
                flag =
                  selectedFilter['Nature'].notInList.indexOf(
                    task.isPrivate ? 'Private' : 'Shared'
                  ) === -1
              }
            }

            if (flag && selectedFilter['Priority']) {
              if (task.priority) {
                if (selectedFilter['Priority'].inList?.length > 0) {
                  flag =
                    selectedFilter['Priority'].inList.indexOf(task.priority) !==
                    -1
                }

                if (flag && selectedFilter['Priority'].notInList?.length > 0) {
                  flag =
                    selectedFilter['Priority'].notInList.indexOf(
                      task.priority
                    ) === -1
                }
              }
            }

            if (flag && selectedFilter['Due Date'] && task.dueDate) {
              if (selectedFilter['Due Date'].inList) {
                flag =
                  (selectedFilter['Due Date'].inList.indexOf('Overdue') !==
                    -1 &&
                    new Date(task.dueDate).getTime() < new Date().getTime()) ||
                  (selectedFilter['Due Date'].inList.indexOf(
                    'Due in next week'
                  ) !== -1 &&
                    new Date(task.dueDate).getTime() - new Date().getTime() <=
                      7 * 86400000 &&
                    new Date(task.dueDate).getTime() - new Date().getTime() >=
                      0) ||
                  (selectedFilter['Due Date'].inList.indexOf(
                    'Due in next 2 days'
                  ) !== -1 &&
                    new Date(task.dueDate).getTime() - new Date().getTime() <=
                      2 * 86400000 &&
                    new Date(task.dueDate).getTime() - new Date().getTime() >=
                      0) ||
                  (selectedFilter['Due Date'].inList.indexOf('Not due') !==
                    -1 &&
                    new Date(task.dueDate).getTime() >= new Date().getTime())
              }
              if (flag && selectedFilter['Due Date'].notInList) {
                flag = !(
                  (selectedFilter['Due Date'].notInList.indexOf('Overdue') !==
                    -1 &&
                    new Date(task.dueDate).getTime() < new Date().getTime()) ||
                  (selectedFilter['Due Date'].notInList.indexOf(
                    'Due in next week'
                  ) !== -1 &&
                    new Date(task.dueDate).getTime() - new Date().getTime() <=
                      7 * 86400000 &&
                    new Date(task.dueDate).getTime() - new Date().getTime() >=
                      0) ||
                  (selectedFilter['Due Date'].notInList.indexOf(
                    'Due in next 2 days'
                  ) !== -1 &&
                    new Date(task.dueDate).getTime() - new Date().getTime() <=
                      2 * 86400000 &&
                    new Date(task.dueDate).getTime() - new Date().getTime() >=
                      0) ||
                  (selectedFilter['Due Date'].notInList.indexOf('Not due') !==
                    -1 &&
                    new Date(task.dueDate).getTime() >= new Date().getTime())
                )
              }
            }

            if (flag) {
              temp[index].docs.push(task)
              if (new Date().getTime() > new Date(task.dueDate)) {
                overdue++
              }
            }
          })
        }
        if (list.status !== 'DONE') {
          temp[index].overdue =
            overdue !== 0 && temp[index].docs.length > 0
              ? ((overdue / temp[index].docs.length) * 100).toFixed()
              : ''
        }
      })
      setData(temp)
    } else {
      setData([
        { status: 'OPEN', docs: [], overdue: 0 },
        { status: 'IN_PROGRESS', docs: [], overdue: 0 },
        { status: 'DONE', docs: [], overdue: 0 },
      ])
    }
  }, [tasksData, filters])

  const updateTask = useCallback(
    async (id, status) => {
      await updateTaskStatus(id, { newStatus: status })
      if (id === searchParams.get('task')) {
        navigate(
          `/tasks/?tag=${
            searchParams.get('tag') && searchParams.get('tag')
          }&task=${searchParams.get('task')}&card=&updated=${true}`
        )
      }
    },
    [navigate, searchParams]
  )
  const handleDragEnd = useCallback(
    ({ draggableId, type, source, destination }) => {
      const temp = [...data]
      const sourceIndex = parseInt(source.droppableId.split(':')[1])
      const destinationIndex = parseInt(destination.droppableId.split(':')[1])
      const taskId = draggableId.split(':')[1]
      temp[sourceIndex].docs.forEach((item, index) => {
        if (taskId === item._id) {
          temp[sourceIndex].docs.splice(index, 1)
          temp[destinationIndex].docs = [
            ...temp[destinationIndex].docs.slice(0, destination.index),
            { ...item },
            ...temp[destinationIndex].docs.slice(destination.index),
          ]
        }
      })
      temp.forEach((list, listIndex) => {
        let overdue = 0
        list?.docs?.forEach((task) => {
          if (new Date().getTime() > new Date(task.dueDate)) {
            overdue++
          }
        })
        if (list.status !== 'DONE') {
          temp[listIndex].overdue =
            overdue !== 0 && temp[listIndex].docs.length > 0
              ? ((overdue / temp[listIndex].docs.length) * 100).toFixed()
              : ''
        }
      })
      setData([...temp])
      updateTask(taskId, data[destinationIndex].status)
    },
    [data, updateTask]
  )
  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <div className='lists'>
        {data?.length > 0 &&
          data?.map((item, index) => (
            <List
              setSlackShareData={setSlackShareData}
              data={item}
              key={`board-list-%${index}`}
              listIndex={index}
            />
          ))}
      </div>
    </DragDropContext>
  )
}

export default Board
